import { Component, Input, OnDestroy, OnInit } from '@angular/core';

@Component({
    selector: 'doc-no-data',
    templateUrl: 'no-data.component.html',
    styleUrls: ['no-data.component.scss']
})

export class DocNoDataComponent implements OnInit {

    @Input() msg: string = '';
    constructor() { }

    ngOnInit() { }

}